// Why the API says a completed review's next review date cannot be changed, keyed by the
// nextReviewDateBlockedReason it returns beside nextReviewDateEditable on the completed review.
const nextReviewDateBlockedMessages = {
    NOCUSTOMDATE: () => "This review type does not allow a custom next review date.",
    ONHOLD: (employeeName) => `${employeeName} is on hold, so their next review date cannot be changed.`,
    TYPEDISABLED: () => "This review type is switched off, so the next review date cannot be changed.",
    NOTAPPLICABLE: (employeeName) => `This review type no longer applies to ${employeeName}, so their next review date cannot be changed.`
};

const unknownNextReviewDateBlockedMessage = "The next review date cannot be changed on this review.";

// A reason this page does not recognise still explains that the date cannot be changed.
export function getNextReviewDateBlockedMessage(nextReviewDateBlockedReason, employeeName) {
    if (!Object.hasOwn(nextReviewDateBlockedMessages, nextReviewDateBlockedReason)) {
        return unknownNextReviewDateBlockedMessage;
    }

    return nextReviewDateBlockedMessages[nextReviewDateBlockedReason](employeeName);
}
